exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs {\r\n    display: flex;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n    .tabs button {\r\n        padding: 10px 20px;\r\n        margin-right: 10px;\r\n        cursor: pointer;\r\n        background-color: #f0f0f0;\r\n        border: 1px solid #ddd;\r\n    }\r\n\r\n        .tabs button.active {\r\n            background-color: #2d3e7c;\r\n            color: white;\r\n            border: 1px solid #007bff;\r\n        }\r\n\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/components/Projects/Index.css
// module id = 431
// module chunks = 0